import { createSelector } from 'reselect';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getUserInfo = state => ({
  realName: localState(state).settings.realName,
  gender: localState(state).settings.gender,
  birthday: localState(state).settings.birthday
});
export const getIsOnHoliday = state => localState(state).settings.isOnHoliday;
export const getIsDarkMode = state => localState(state).settings.isDarkMode;
export const getUsername = state => localState(state).settings.username;
export const getAccountSettings = state => localState(state).settings;
export const getSettingsUiState = state => localState(state).uiState;
export const getError = state => localState(state).error;
export const getIsInternationalTradingEnabled = createSelector(getAccountSettings, _ref => {
  let {
    isInternationalTradingEnabled
  } = _ref;
  return isInternationalTradingEnabled;
});